import { Skeleton } from "@musa.tech/design-system";

/**
 * Skeleton de loading dos 3 KPI cards — mesmo grid de `KpiCardsRow`, pra não
 * pular de "1 bloco cheio" pra "3 cards" quando o dado chega.
 */
export const KpiCardsRowSkeleton = () => (
  <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
    <Skeleton className="rounded-2xl" style={{ height: "177px" }} />
    <Skeleton className="rounded-2xl" style={{ height: "177px" }} />
    <Skeleton className="rounded-2xl" style={{ height: "177px" }} />
  </div>
);
